import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import ScrollArea from 'react-scrollbar';
import moment from 'moment';

import IconLeft from 'material-ui/svg-icons/navigation/chevron-left';
import IconRight from 'material-ui/svg-icons/navigation/chevron-right';

import * as userActions from '../../actions/entities/UserActions';
import { Grid, GridHeader, GridBody, GridRow, GridCell, GridFooter } from '../../components/basic/grid';
import PlainTextField from '../../components/basic/PlainTextField';
import IconButton from '../../components/basic/IconButton';
import AdminOnly from './AdminOnly';

import { getUsersFilteredPage } from '../../selectors/UsersSelector';

const CLIENTS = {
  DASHBOARD: { key: 'DASHBOARD', label: 'Dashboard' },
  ADMIN: { key: 'ADMIN', label: 'Admin' },
  PORTAL: { key: 'PORTAL', label: 'Portal' }
};

const AUTHORITIES = {
  ADMIN: {
    label: 'Admin',
    clients: ['DASHBOARD']
  },
  ADMIN_LOCAL: {
    label: 'Local admin',
    clients: ['ADMIN', 'DASHBOARD']
  },
  APPLICANT: {
    label: 'Participant',
    clients: ['PORTAL']
  },
  OPERATOR: {
    label: 'Operator',
    clients: ['DASHBOARD']
  },
  DESIGNER: {
    label: 'Designer',
    clients: ['DASHBOARD']
  }
};

const camelToUpperUnderscore = value => {
  if (!value) {
    return null;
  }
  let res = '';
  for (var i = 0; i < value.length; i += 1) {
    const c = value[i];
    if (c < 'a') {
      res += '_';
    }
    res += c.toUpperCase();
  }
  return res;
};

window.R = R;

class UsersContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: this.props.filter
    };
  }

  componentDidMount() {
    const { fetchUsers } = this.props;
    fetchUsers();
  }

  componentWillUnmount() {
    if (this.filterSetTimeout) {
      clearTimeout(this.filterSetTimeout);
    }
  }

  setFilter = ({ target: { value } }) => {
    this.setState({ filter: value });
    if (this.filterSetTimeout) {
      clearTimeout(this.filterSetTimeout);
    }
    this.filterSetTimeout = setTimeout(() => {
      this.props.setUsersFilter(value);
    }, 300);
  };

  render() {
    const { users, setUsersPage, impersonateUser } = this.props;
    return (
      <div className="flex flex1">
        <Grid>
          <GridHeader>
            <GridRow className="row">
              <GridCell className="col-md-5 col-sm-12">
                <span>Name</span>
              </GridCell>
              <GridCell className="col-md-4 col-sm-6">
                <span>Stats</span>
              </GridCell>
              <GridCell className="col-md-3 col-sm-6">
                <span>Authorities</span>
              </GridCell>
            </GridRow>
            <GridRow className="row" style={{ padding: 0 }}>
              <GridCell className="col-sm-12" style={{ padding: 0 }}>
                <PlainTextField
                  placeholder="Filter..."
                  value={this.state.filter}
                  onChange={this.setFilter}
                  label="Filter"
                />
              </GridCell>
            </GridRow>
          </GridHeader>
          <ScrollArea smoothScrolling>
            <GridBody>
              {R.map(
                u => (
                  <GridRow key={u.id} className="row">
                    <GridCell className="col-md-5 col-sm-12">
                      {u.lastName || u.firstName ? (
                        <span>
                          {u.lastName} {u.firstName} {u.email && `(${u.email})`}
                        </span>
                      ) : (
                        <em>Unnamed</em>
                      )}
                      <br />
                      <div>
                        <small className="font-weight-light">Created at {moment(u.createdAt).format('L LT')}</small>
                      </div>
                      {u.activatedAt ? (
                        <div>
                          <small className="font-weight-light">
                            Activated at {moment(u.activatedAt).format('L LT')}
                          </small>
                        </div>
                      ) : (
                        <div>
                          <small className="font-weight-light">Not activated yet</small>
                        </div>
                      )}
                    </GridCell>
                    <GridCell className="col-md-4 col-sm-6">
                      {R.map(
                        ({ key, stats }) => (
                          <div key={key}>
                            <strong>{stats.count}</strong>
                            <span>
                              {' '}
                              login{stats.count === 1 ? '' : 's'} to {CLIENTS[key].label}
                            </span>
                            <small className="font-weight-light">
                              {' '}
                              (latest at {moment(stats.last).format('L LT')})
                            </small>
                          </div>
                        ),
                        R.filter(
                          s => !!s,
                          R.map(
                            c => {
                              const stats = u.stats && u.stats.logins && u.stats.logins[c];
                              if (stats) {
                                return {
                                  key: c,
                                  stats
                                };
                              }
                              return null;
                            },
                            ['DASHBOARD', 'ADMIN', 'PORTAL']
                          )
                        )
                      )}
                      {R.map(k => {
                        const s = u.guideStates[k];
                        return (
                          <div key={k} style={{ lineHeight: '1.3em' }}>
                            <small>
                              {CLIENTS[camelToUpperUnderscore(k)].label} guide (v{s.version}) at step {s.step}{' '}
                              {s.shown ? 'shown' : 'hidden'} and{' '}
                              {s.finishedAt
                                ? `finished for the first time at ${moment(s.finishedAt).format('L LT')}`
                                : 'not yet finished'}
                            </small>
                          </div>
                        );
                      }, R.keys(u.guideStates))}
                    </GridCell>
                    <GridCell className="col-md-3 col-sm-6">
                      {R.map(a => {
                        const auth = AUTHORITIES[a] || { label: a, clients: [] };
                        return (
                          <div key={a}>
                            <span style={{ verticalAlign: 'middle' }}>{auth.label}</span>
                            <AdminOnly noProd>
                              {R.map(
                                c => (
                                  <a
                                    key={c}
                                    role="button"
                                    style={{
                                      verticalAlign: 'middle',
                                      marginLeft: '8px'
                                    }}
                                    onClick={() => impersonateUser(u.id, c)}
                                  >
                                    {`Go to ${CLIENTS[c].label}`}
                                  </a>
                                ),
                                auth.clients
                              )}
                            </AdminOnly>
                          </div>
                        );
                      }, u.authorities)}
                    </GridCell>
                  </GridRow>
                ),
                users.items
              )}
            </GridBody>
          </ScrollArea>
          <GridFooter>
            <GridRow className="Grid-pagination row">
              <GridCell className="col-sm-12 text-right">
                <span>
                  {users.page * users.size + 1}-{(users.page + 1) * users.size} of {users.totalSize}
                </span>
                <IconButton onClick={() => setUsersPage(users.page - 1)} disabled={users.page <= 0}>
                  <IconLeft />
                </IconButton>
                <IconButton
                  onClick={() => setUsersPage(users.page + 1)}
                  disabled={(users.page + 1) * users.size > users.totalSize}
                >
                  <IconRight />
                </IconButton>
              </GridCell>
            </GridRow>
          </GridFooter>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({ users: getUsersFilteredPage(state), filter: state.entities.users.filter });

export default connect(mapStateToProps, userActions)(UsersContainer);



// WEBPACK FOOTER //
// ./src/containers/private/UsersContainer.js